// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"cc363a9d","592":"cef72a76"}[chunkId] + ".chunk.js";
};